import {Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {UserInformationDto} from "../../../dto/user.information.dto";
import {Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'app-personal-data',
    templateUrl: './personal-data.component.html',
    styleUrls: ['./personal-data.component.scss']
})
export class PersonalDataComponent implements OnInit {
    @Input() isMenu: boolean = false;
    userInformation: UserInformationDto | undefined;

    constructor(private userService: UserService,
                private router: Router,
                private authService: AuthService) {
    }

    ngOnInit(): void {
        this.getUserinfoService();
    }

    getUserinfoService() {
        this.userService.getUserInfo().subscribe(
            response => {
                this.userInformation = response;
                console.log('Información del usuario', this.userInformation);
            }, error => {
                console.error('Error al obtener la información del usuario', error);
            }
        );
    }
    // Métodos para manejar la edición de cada campo
    editName() {
        // Lógica para editar el nombre (por ejemplo, abrir un modal de edición)
        console.log("Edit Name Clicked");
    }

    editEmail() {
        // Lógica para editar el email
        console.log("Edit Email Clicked");
    }

    editPassword() {
        // Lógica para editar la contraseña
        console.log("Edit Password Clicked");
    }
    verificationCI() {
        this.router.navigate(['/register-document']);
    }

    verificationEmail() {
        this.router.navigate(['/register-document']);
    }

    verificationCell() {
        this.router.navigate(['/register-document']);
    }

    logout() {
        this.authService.logout();
    }


}
